<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">
      <label style="cursor:pointer;" @click="goBack">{{ $t('CommunicationConfiguration') }}</label> >
      {{ $t('permissionsInformation') }}
    </div>
    <div class="main common-table-cnt">
      <div class="search search-container">
        <!-- 查询form 表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('permissionName')">
            <el-input v-model="formInline.permissionsName" clearable :placeholder="$t('permissionName')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="searchList">{{ $t('query') }}</el-button>
            <el-button type="primary" class="add-btn" @click="addPermissions">{{ $t('newlyAded') }}</el-button>
            <el-button type="primary" class="add-btn" @click="backLast">{{ $t('returnM') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <!-- table 组件 -->
        <Table :data="tableData" :columns="columns" :operation="dateOperation" :showSelcet="false" @operate="operationEvent" @sortChange="handleSort"></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增/编辑 弹窗 -->
    <el-dialog
      :title="
        editPermissions ? $t('newlyAded') + $t('permissionsInformation') : $t('edit') + $t('permissionsInformation')
      "
      :visible.sync="dialogChannel"
      :append-to-body="true"
      class="common-blue-contain"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="fromData">
        <div class="settingDialog">
          <el-form-item :label="$t('permissionCode')" :label-width="formLabelWidth" :required="true">
            <el-input
              v-model="fromData.permissionsId"
              autocomplete="off"
              :placeholder="$t('permissionCode')"
              :disabled="editPermissions ? false : true"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('permissionName')" :label-width="formLabelWidth" :required="true">
            <el-input
              v-model="fromData.permissionsName"
              autocomplete="off"
              :placeholder="$t('permissionName')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('remarks')" :label-width="formLabelWidth">
            <el-input
              v-model="fromData.description"
              autocomplete="off"
              :placeholder="$t('remarks')"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitPermission(editPermissions)">{{ $t('determine') }}</el-button>
        <el-button @click="dialogChannel = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Table from '@/components/NewTable'
import { getHelmetPermission, addHelmetPermission, deleteHelmetPermission } from '@/api/setting'
import { errorMessage, success } from '@/util/common'
import { errorCollection } from '@/api/dmp/dmpCollection'
export default {
  data() {
    return {
      formInline: {
        permissionsName: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      dialogChannel: false,
      editPermissions: false,
      fromData: {
        permissionsId: '',
        permissionsName: '',
        description: '',
      },
      formLabelWidth: '150px',
    }
  },
  components: {
    Table,
  },
  methods: {
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.column.sortable
      this.formInline.useAsc = data.order=== "descending" ? 0 : 1
      this.searchList()
    },
    goBack() {
      this.$router.push({ path: 'message' })
    },
    // 提交 新增/ 编辑的内容
    submitPermission() {
      let param = {
        permissionsId: this.fromData.permissionsId,
        description: this.fromData.description,
        permissionsName: this.fromData.permissionsName,
      }
      // 判断表单是否填入内容 提示
      if (this.fromData.permissionsId === '') {
        errorCollection('通信配置-权限信息', '新增/编辑设备权限', {
          status: 200,
          data: { state: -1, msg: '请输入权限编码' },
        })
        errorMessage(this.$t('pleaseEnter') + this.$t('permissionCode'))
        return
      } else if (this.fromData.permissionsId.indexOf('#') !== -1) {
        errorCollection('通信配置-权限信息', '新增/编辑设备权限', {
          status: 200,
          data: { state: -1, msg: '权限编码不含 ‘#’' },
        })
        errorMessage(this.$t('permissionCodeDoesInclude') + ' ‘#’')
        return
      } else if (this.fromData.permissionsId.indexOf('[') !== -1 || this.fromData.permissionsId.indexOf(']') !== -1) {
        errorCollection('通信配置-权限信息', '新增/编辑设备权限', {
          status: 200,
          data: { state: -1, msg: '权限编码不含 ‘[’ ‘]’' },
        })
        errorMessage(this.$t('permissionCodeDoesInclude') + '‘[ 或 ]’ ')
        return
      } else if (this.fromData.permissionsName === '') {
        errorCollection('通信配置-权限信息', '新增/编辑设备权限', {
          status: 200,
          data: { state: -1, msg: '请输入权限名称' },
        })
        errorMessage(this.$t('pleaseEnter') + this.$t('permissionName'))
        return
      } else {
        // 输入完成后请求 添加/编辑 接口
        addHelmetPermission(param).then(res => {
          if (res.state === 0) {
            this.dialogChannel = false
            this.basicConfig()
          }
        })
      }
    },
    // 点击新增按钮
    addPermissions() {
      // 清空 from表单
      this.fromData = {
        permissionsId: '',
        permissionsName: '',
        description: '',
      }
      // 显示弹窗
      this.dialogChannel = true
      // 区别弹窗 true：新增 false：编辑
      this.editPermissions = true
    },
    // 返回上一页
    backLast() {
      // 返回上一页
      this.$router.push({ path: '/newIndex/newSet/message' })
    },
    operationEvent(type, value, index) {
      console.log(type, value, index, 'type, value, index')
      if (type.type === 'edit') {
        this.editPermissionsInfo(type.value)
      } else {
        this.delectInfo(type.value)
      }
    },
    // 编辑其中一条信息
    editPermissionsInfo(row) {
      // 回显数据
      this.fromData = Object.assign({}, row)
      // 显示弹窗
      this.dialogChannel = true
      // 区别弹窗 true：新增 false：编辑
      this.editPermissions = false
    },
    delectInfo(row) {
      this.$confirm(this.$t('deleteThisInformation'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = { id: row.permissionsId }
        deleteHelmetPermission(param).then(res => {
          if (res.state === 0) {
            success(this.$t('deleteSuccess'))
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.basicConfig()
    },
    // 根据条件进行查询
    searchList() {
      this.currentPage = 1
      this.basicConfig()
    },
    // 基础配置信息
    basicConfig() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        permissionsName: this.formInline.permissionsName,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getHelmetPermission(param).then(res => {
        if (res.state === 0) {
          this.tableData = res.value.content
          this.totalData = res.value.totalElements
        }
      })
      this.columns = [
        {
          attrName: 'permissionsId',
          label: this.$t('permissionCode'),
          sort: 'permissionsId',
        },
        {
          attrName: 'permissionsName',
          label: this.$t('permissionName'),
          sort: 'permissionsName',
        },
        {
          attrName: 'description',
          label: this.$t('remarks'),
          sort: 'description',
        },
      ]
      this.dateOperation = [
        {
          operateName: this.$t('edit'),
          type: 'edit',
          IsHad: '',
          class: 'editClick',
        },
        {
          operateName: this.$t('delete'),
          type: 'delect',
          IsHad: '',
          class: 'editClick',
        },
      ]
    },
  },
  created() {
    this.basicConfig()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
</style>
